import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { useEffect, useState } from "react";
import { Datalayer, getAnalytics } from "@miro-site/analytics";
function sendAccountPickerShownEvent() {
    return _sendAccountPickerShownEvent.apply(this, arguments);
}
function _sendAccountPickerShownEvent() {
    _sendAccountPickerShownEvent = _async_to_generator(function() {
        var analytics, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    analytics = getAnalytics();
                    return [
                        4,
                        analytics.sendEvent(new Datalayer("accountPickerShown", {
                            openedFrom: "templates"
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _sendAccountPickerShownEvent.apply(this, arguments);
}
function sendAccountSelectedInAccountPickerEvent(_, callback) {
    return _sendAccountSelectedInAccountPickerEvent.apply(this, arguments);
}
function _sendAccountSelectedInAccountPickerEvent() {
    _sendAccountSelectedInAccountPickerEvent = _async_to_generator(function(param, callback) {
        var accountId, accountsListIndex, workspaceKey, analytics, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    accountId = param.accountId, accountsListIndex = param.accountsListIndex, workspaceKey = param.workspaceKey;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    analytics = getAnalytics();
                    return [
                        4,
                        analytics.sendEvent(new Datalayer("accountPickerAccountSelected", {
                            accountsListIndex: accountsListIndex,
                            accountId: accountId,
                            workspaceKey: workspaceKey
                        }))
                    ];
                case 2:
                    _state.sent();
                    if (callback) {
                        callback();
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _sendAccountSelectedInAccountPickerEvent.apply(this, arguments);
}
export function useAccountPicker(param) {
    var onAccountLoaded = param.onAccountLoaded, onAccountSubmited = param.onAccountSubmited, onAccountCancel = param.onAccountCancel, onAccountError = param.onAccountError;
    var ref = useState(false), isAccountPickerVisible = ref[0], setAccountPickerVisible = ref[1];
    useEffect(function() {
        if (isAccountPickerVisible) {
            sendAccountPickerShownEvent();
        }
    }, [
        isAccountPickerVisible
    ]);
    var onAccountPickerLoaded = function(accountsIds, workspaceKey) {
        if (!Array.isArray(accountsIds)) {
            return;
        }
        var accountsLength = accountsIds.length;
        switch(accountsLength){
            //in application user will use account creation flow
            case 0:
                onAccountLoaded(undefined, workspaceKey);
                break;
            //copy board to single account. no need to select
            case 1:
                onAccountLoaded(accountsIds[0], workspaceKey);
                break;
            //user will select account to copy board
            default:
                setAccountPickerVisible(true);
                break;
        }
    };
    var onAccountPickerSubmit = function(accountId, accountsListIndex, workspaceKey) {
        sendAccountSelectedInAccountPickerEvent({
            accountId: accountId,
            accountsListIndex: accountsListIndex,
            workspaceKey: workspaceKey
        }, function() {
            onAccountSubmited(accountId, workspaceKey);
        });
    };
    var onAccountPickerCancel = function() {
        onAccountCancel();
        setAccountPickerVisible(false);
    };
    return [
        isAccountPickerVisible,
        onAccountPickerLoaded,
        onAccountPickerSubmit,
        onAccountPickerCancel,
        onAccountError, 
    ];
}
